const EmptyVideoState = ({ label }: { label: string }) => (
  <div className="flex h-full min-h-[240px] items-center justify-center bg-muted/40 text-sm text-muted-foreground">
    {label}
  </div>
);

export default EmptyVideoState;
